<template>
  <div>
      <!--<div class="banner" v-bind:style="{backgroundImage:'url(' + bg + ')',height:'400px',backgroundSize:'auto'}">-->
    <div class="home-banner" v-bind:style="{backgroundImage:'url(' + bg + ')'
    ,backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}">
        <head-menu :width1="width2"  fd="0"  current="7"></head-menu>
      <img  :src="bg" class="home-banner-img" style="width: auto;height:auto;max-width: 100%;max-height:99%">
      </div>
    <el-row class="show-home-head-tlie2" style="margin-top: 70px">
      <el-col :lg="{span:11,offset:0}" :md="{span:8,offset:0}" :xs="24">
        <div style="width: 98%;height: 1px;background-color:rgb(229, 229, 229);margin-top:26px;" ></div>
      </el-col>
      <el-col :lg="{span:13,offset:0}" :md="{span:16,offset:0}" :xs="24"  >
        <h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 99%;margin-left: 1%">
          <span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px">About Us</span>
        </h3>
        <!--<div  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left: 1%;color: #666666">道远资本&nbsp;&nbsp;<span style="color: #083A6F;font-size: 30px">关于我们</span></div>-->

        <div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left: 1%;color: #083A6F">&nbsp;&nbsp;&nbsp;&nbsp;关于我们</div>
      </el-col>
    </el-row>
    <div style="text-align:center;font-weight: bold;padding-bottom: 10px;border-bottom:1px solid #e5e5e5" class="show-home-head-tlie portfolio-font-EN-size  about-font-EN-top">About Us</div>
    <div class="show-home-head-tlie portfolio-font-CN-size"  style="color:rgba(8,58,111,1);margin-top: 10px;text-align: center;margin-bottom: 20px">关于我们</div>

      <div style="max-width: 1210px;margin: 0 auto" class="text-top">
        <el-row >
          <el-col  :lg="{span:12,offset:0}" :sm="{span:24,offset:0}" :md="{span:12,offset:0}" :xs="24">
            <img @mouseover="yqrth(1)" @mouseout="yqrth(2)" style="display: block;width: 100%;margin-top: 7px" :src="yqr">
          </el-col>
          <el-col  v-if="language == 'CN'" style="margin-top: 30px" :lg="{span:11,offset:1}" :sm="{span:24,offset:0}" :md="{span:11,offset:1}" :xs="{span:22,offset:1}"  >
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">使命：道远资本</span>是专注于医疗健康行业的新锐投资机构，致力于用资本的力量和产业资源帮助优秀医疗健康企业快速成长，为社会提供更好的医疗产品和服务，增进人类健康。</span>
              <br>
              <span class="home-head-txt"  style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;" >产业：</span>我们的投资范围包括制药、医疗器械、生物技术、医疗服务和数字医疗等各细分领域，涵盖了初创、成长、成熟期等企业成长的各个阶段。</span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">能力：</span>我们的投资团队成员来自于知名投资机构、医药机械企业和科研机构，拥有丰富的产业经验和投资经验，善于识别和挖掘医疗健康行业的投资机会。</span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">成果：</span>道远资本创立于2014年，2019-2020年有9家企业实现在港股和科创板上市，包括锦欣生殖（01951.HK）、维亚生物（01873.HK）等。2021年截至日前，道远资本旗下基金所投资的贝康医疗（02170.HK）、三叶草生物(02197.HK)在港交所上市，另有2家企业通过创业板上市委会议，1家企业通过港交所上市聆讯，2家企业申报IPO获受理；预计未来2年内还会有超过10家投资企业在国内外主要证交所上市。</span>
            <br>
            <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">声誉：</span>道远资本以其广泛充沛的项目资源、深入细致的尽职调查、专业精准的项目判断、灵活高效的股权交易技能受到被投资企业、业界同行和有限合伙出资人的广泛赞誉。</span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em; color: #083A6F;font-weight:bold;">道远资本目前管理12支人民币基金，2支美元基金，已投资金额近30亿元人民币，现阶段投资项目72个。</span>
          </el-col>
          <!-- 英文 -->
          <el-col  v-if="language == 'EN'" style="margin-top: 30px" :lg="{span:11,offset:1}" :sm="{span:24,offset:0}" :md="{span:11,offset:1}" :xs="{span:22,offset:1}"  >
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">Mission:</span>Our mission is to provide better medical products and devices for society and enhance human health by helping outstanding healthcare companies grow rapidly with capital and industrial resources. </span>
              <br>
              <span class="home-head-txt"  style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;" >Industry:</span>We invest in companies in pharmaceuticals, medical devices, biotechnology, medical services, and digital healthcare in different stages from seed to pre-IPO. </span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">Team:</span>Our investment team members come from leading investment institutions, pharmaceutical and medical devices companies, and scientific research institutions with rich industrial and investment experience.</span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">IPOs:</span> Tao Capital was founded in 2014. Eleven companies have been listed on the Hong Kong Stock Market and the Science and Technology Innovation Board from 2019 to 2021, including Jinxin Fertility (01951. HK), Viva Biotech (01873. HK), Basecare (02170.HK), Clover Biopharmaceuticals (02197.HK), and so on. By the end of 2021, two other companies have passed the Listing Committee meeting of the Science and Technology Innovation Board and the Growth Enterprise Market (GEM), one enterprise has passed the hearing of the Hong Kong Stock Exchange, and two enterprises’ IPO applications were accepted. In addition, more than 10 investment companies are expected to list on major domestic and international stock exchanges in the next two years.</span>
            <br>
            <span class="home-head-txt" style="line-height: 30px;font-size: 1em"><span style="color: #083A6F;font-weight:bold;">Reputation:</span>Tao Capital has been widely praised by portfolio companies, industry peers and limited partnership investors for its extensive project resources, in-depth due diligence, professional and accurate and thoughtful judgment, and flexible and efficient equity investment skills.</span>
              <br>
              <span class="home-head-txt" style="line-height: 30px;font-size: 1em; color: #083A6F;font-weight:bold;">Tao Capital currently manages 12 RMB funds and 2 US dollar funds with about 3 billion RMB asset under management and 72 portfolio companies.</span>
          </el-col>
        </el-row>
      </div>
    <el-row class="show-home-head-tlie2" style="margin-top: 140px">
        <el-col :lg="{span:11,offset:0}" :md="{span:12,offset:0}" :xs="24" style="">
        <div style="width: 100%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 26px;" ></div>
      </el-col>
      <el-col  :lg="{span:13,offset:0}" :md="{span:12,offset:0}" :xs="24" style="" >
        <h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 99%;margin-left: 1%">
          <span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px">IPOs</span>
        </h3>
        <div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 100%;margin-left:0%">上市企业</div>
      </el-col>
    </el-row>
    <div style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5" class="show-home-head-tlie portfolio-top portfolio-font-EN-size">IPOs</div>
    <div class="show-home-head-tlie"  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;">上市企业</div>
      <div style="max-width: 1210px;margin: 0 auto;margin-top:30px;margin-bottom: 10px">
      <el-row>
        <el-col :lg="24" >
        <el-row>
          <el-col :lg="{span:6,offset:0}" >
            <span class="test">
          <div class="imgDiv">
          <img :src="dataImg[0].img" style="display: block;width: 100%"/>
          <div class="textBody">
          <div class="tile1" style="margin-top: 9px;text-align: center">赛诺医疗</div>
          <div class="tile2" style="margin-top: 3px;text-align: center">（688108.SH）</div>
          <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国心脏支架行业第一阵营企业</div>
          <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">The first camp enterprise in China's cardiac stent industry</div>
        </div>
      </div>
      </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
            <span class="test">
              <div class="imgDiv">
                <img :src="dataImg[1].img" style="display: block;width: 100%"/>
                <div class="textBody">
                  <div class="tile1" style="margin-top: 9px;text-align: center">维亚生物</div>
                  <div class="tile2" style="margin-top: 3px;text-align: center">（01873.HK）</div>
                  <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">专注于创新药早期研发服务和投资的生物技术公司</div>
                  <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">A biotechnology company focused on early-stage R&D services and investment in innovative medicines</div>
                </div>
              </div>
            </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
            <span class="test">
            <div class="imgDiv">
                <img :src="dataImg[2].img" style="display: block;width: 100%"/>
              <div class="textBody">
                <div class="tile1" style="margin-top: 9px;text-align: center">锦欣生殖</div>
                <div class="tile2" style="margin-top: 3px;text-align: center">（01951.HK）</div>
                <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国领先的人类辅助生殖医疗机构</div>
                <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">China's leading human assisted reproductive health institution</div>
              </div>
            </div>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="{span:6,offset:0}">
           <span class="test">
            <div class="imgDiv">
              <img :src="'http://47.94.156.156/home/borui.jpg'" style="display: block;width: 100%"/>
              <div class="textBody">
                <div class="tile1" style="margin-top: 9px;text-align: center">博瑞生物医药（苏州）股份有限公司</div>
                <div class="tile2" style="margin-top: 3px;text-align: center">688166</div>
                <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">全球领先的创新性高端化学制药公司</div>
                <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">The world's leading innovative high-end chemical and pharmaceutical company</div>
              </div>
            </div>
        </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
          <span class="test">
        <div class="imgDiv">
          <img :src="'http://47.94.156.156/home/suoshi.jpg'" style="display: block;width: 100%"/>
          <div class="textBody">
            <div class="tile1" style="margin-top: 9px;text-align: center">硕世生物科技股份有限公司</div>
            <div class="tile2" style="margin-top: 3px;text-align: center">688399</div>
            <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国领先的IVD公司</div>
            <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">China's leading IVD company</div>
          </div>
        </div>
        </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
            <span class="test">
            <div class="imgDiv">
              <img :src="'http://47.94.156.156/home/anbiping.jpg'" style="display: block;width: 100%"/>
              <div class="textBody">
                <div class="tile1" style="margin-top: 9px;text-align: center">广州安必平医药科技股份有限公司</div>
                <div class="tile2" style="margin-top: 3px;text-align: center">688393</div>
                <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国肿瘤病理诊断领域的领导者</div>
                <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">A leader in the field of tumor pathology diagnosis in China</div>
              </div>
            </div>
          </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="{span:6,offset:0}">
           <span class="test">
            <div class="imgDiv">
              <img :src="'http://47.94.156.156/home/tianzhihang.jpg'" style="display: block;width: 100%"/>
              <div class="textBody">
                <div class="tile1" style="margin-top: 9px;text-align: center">北京天智航技术有限公司</div>
                <div class="tile2" style="margin-top: 3px;text-align: center">688277</div>
                <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国手术导航与医疗机器人领域的行业领导者</div>
                <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">Industry leader in surgical navigation and medical robotics in China</div>
              </div>
            </div>
        </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
            <span class="test">
            <div class="imgDiv">
                <img :src="dataImg[9].img" style="display: block;width: 100%" />
              <div class="textBody">
                <div class="tile1" style="margin-top: 9px;text-align: center">苏州贝康医疗股份有限公司</div>
                <div class="tile2" style="margin-top: 3px;text-align: center">02170.HK</div>
                <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">中国辅助生殖诊断领域龙头企业</div>
                <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">A leading enterprise in the field of assisted genital diagnosis in China</div>
              </div>
            </div>
          </span>
          </el-col>
          <el-col :lg="{span:6,offset:3}">
              <span class="test">
              <div class="imgDiv">
                <img class="home-log-img" :src="'http://47.94.156.156/home/aidi.jpg'" style="display: block;width: 100%"/>
                <div class="textBody">
                  <div class="tile1" style="margin-top: 9px;text-align: center">江苏艾迪药业股份有限公司</div>
                  <div class="tile2" style="margin-top: 3px;text-align: center">688488</div>
                  <div v-if="language == 'CN'" class="tile2" style="margin-top: 3px;text-align: center">专注于抗病毒、抗肿瘤等严重影响人类健康疾病领域的产品研发、生产及销售。</div>
                  <div v-if="language == 'EN'" class="tile2" style="margin-top: 3px;text-align: center">Focus on anti-virus, anti-tumor and other product development, production and sales in the field which seriously affecting human health diseases</div>
                </div>
              </div>
              </span>
          </el-col>
        </el-row>
        </el-col>
        </el-row>
        <div style="max-width: 1130px;margin: 0 auto;height: 85px;top:-30px;background:rgba(242,242,242,1);position: relative;z-index:3">
          <div style="height: 30px"></div>
          <div style="width: 91px;height: 21px;float: right">
            <!-- <el-link  style="height: 31px;width:90px;margin-top: 13px;font-size: 13px;line-height:7px;background-color:#083A6F;color: #FFFFFF;border-radius:16px;right: 23px" @click="linkRouter()">查看更多</el-link> -->
          </div>
        </div>
      </div>
    <el-row class="show-home-head-tlie2">
      <el-col :lg="{span:10,offset:0}" :md="{span:10,offset:0}" :xs="24">
        <div style="width: 108%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 50px;" ></div>
      </el-col>
      <el-col :lg="{span:14,offset:0}" :md="{span:14,offset:0}" :xs="24" style="margin-top: 30px"  >
        <h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;margin-left: 8%">
          <span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px">News</span>
        </h3>
        <div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 93%;margin-left: 7%">相关新闻</div>
      </el-col>
    </el-row>
    <div style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5;width: 92%" class="show-home-head-tlie">News</div>
    <div  class="show-home-head-tlie" style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;margin-bottom: 20px">相关新闻</div>

    <div  v-bind:style="width2>750?lgNewsStyle:xsNewsStyle">
      <el-row class="newBodTop"  style="max-width:1210px;margin: 0 auto">
        <el-col class="is-show-time" :span="10">
          <img style="width: 490px; height: 399px" :src="yg">
        </el-col>
        <el-col :lg="{span:14,offset:0}" :sm="{span:24,offset:0}" :md="{span:24,offset:0}" :xs="{span:24,offset:0}">
          <el-timeline class="home-news time-line-paddind" style="background: #fff;min-height:359px">

            <div v-if="widthType==0"  style="height: 20px"></div>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.date"
              >

              <span @click="timeLineClick(activity)" @mouseover="jr(index)" @mouseout="lk(index)" class="home-text">{{activity.title}}</span>
            </el-timeline-item>
          </el-timeline>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 70px"></div>
    <footee></footee>
  </div>
</template>
<script>
import HeadMenu from '../../share/head-mean'
import footee from '../../share/footer.vue'
export default {
    components:{
        "head-menu":HeadMenu,
      "footee":footee
    },
    data(){
        return{

            lgNewsStyle:{
              backgroundImage:'url(' + require('@/assets/3.jpg') + ')',
              height:'648px',
              backgroundSize: 'cover',marginTop:'40px'
            },
            xsNewsStyle:{
            },
            language:"CN",
            width2:1,
            widthType:"0",  //0代表没有 750 1代表有750
            isShowNx:true,
            bg: require('@/assets/home/banner1.jpg'),
            backgroundDiv: {
                backgroundImage:  require('@/assets/home/banner.jpg')
             },
            bannerUrl:require('@/assets/home/banner.jpg'),
            yqr:require('@/assets/home/1.jpg'),
            zfx:require('@/assets/home/3.jpg'),
            dataImg:[
              {
                img:'http://47.94.156.156/home/sainuo.jpg',
//                img:require('@/assets/home/赛诺.jpg'),
                text1:'赛诺医疗',
                text2:'（688108.SH）',
                text3:'中国心脏支架行业第一阵营企业'
              },
              {img:'http://47.94.156.156/home/viva.jpg',
                text1:'维亚生物',
                text2:'（01873.HK）',
                text3:'专注于创新药早期研发服务和投资的生物技术公司'
              },
              {img:'http://47.94.156.156/home/jingxin.jpg',
                text1:'锦欣生殖',
                text2:'（01951.HK）',
                text3:'中国领先的人类辅助生殖医疗机构'
              },
              { img:'http://47.94.156.156/home/purui.jpg',
                text1:'普瑞眼科',
                text2:'',
                text3:'中国领先的眼科专科连锁医院集团'
              },{img:'http://47.94.156.156/home/anjiesi.jpg',
                text1:'安杰思医学科技',
                text2:'',
                text3:'消化道微创介入诊疗器械和设备的国际领先企业'
              },
              {img:'http://47.94.156.156/home/huaketai.jpg',
                text1:'华科泰',
                text2:'',
                text3:'综合性制药企业，中国医疗工业百强'
              },
              {img:'http://47.94.156.156/home/innuote.jpg',
                text1:'英诺特',
                text2:'',
                text3:'中国心脏支架行业第一阵营企业'
              }
              ,{img:'http://47.94.156.156/home/beite.jpg',
                text1:'三叶草生物制药',
                text2:'',
                text3:'呼吸道病毒快速诊断领先企业'

              }
              ,{img:'http://47.94.156.156/home/sanyecao.jpg',
                text1:'成都倍特药业集团',
                text2:'',
                text3:'综合性制药企业，中国医疗工业百强'
              }
              ,{img:'http://47.94.156.156/home/beikang.jpg',
                text1:'成都倍特药业集团',
                text2:'',
                text3:'综合性制药企业，中国医疗工业百强'
              }
              ,{img:'http://47.94.156.156/home/weimou.jpg',
                text1:'成都倍特药业集团',
                text2:'',
                text3:'综合性制药企业，中国医疗工业百强'
              }
              ,{img:'http://47.94.156.156/home/kenite.jpg',
                text1:'成都倍特药业集团',
                text2:'',
                text3:'综合性制药企业，中国医疗工业百强'
              }
            ],

          pcdataImg:[
            {
              img:'http://47.94.156.156/home/sainuo.jpg',
//                img:require('@/assets/home/赛诺.jpg'),
              text1:'赛诺医疗',
              text2:'（688108.SH）',
              text3:'中国心脏支架行业第一阵营企业'
            },
            {img:'http://47.94.156.156/home/viva.jpg',
              text1:'维亚生物',
              text2:'（01873.HK）',
              text3:'专注于创新药早期研发服务和投资的生物技术公司'
            },
            {img:'http://47.94.156.156/home/jingxin.jpg',
              text1:'锦欣生殖',
              text2:'（01951.HK）',
              text3:'中国领先的人类辅助生殖医疗机构'
            },
            {img:'http://47.94.156.156/home/purui.jpg',
              text1:'普瑞眼科',
              text2:'',
              text3:'中国领先的眼科专科连锁医院集团'
            },{img:'http://47.94.156.156/home/anjiesi.jpg',
              text1:'安杰思医学科技',
              text2:'',
              text3:'消化道微创介入诊疗器械和设备的国际领先企业'
            },
            {img:'http://47.94.156.156/home/huaketai.jpg',
              text1:'华科泰',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            },
            {img:'http://47.94.156.156/home/innuote.jpg',
              text1:'英诺特',
              text2:'',
              text3:'中国心脏支架行业第一阵营企业'
            }
            ,{img:'http://47.94.156.156/home/beite.jpg',
              text1:'三叶草生物制药',
              text2:'',
              text3:'呼吸道病毒快速诊断领先企业'

            }
            ,{img:'http://47.94.156.156/home/sanyecao.jpg',
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{img:'http://47.94.156.156/home/beikang.jpg',
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{img:'http://47.94.156.156/home/weimou.jpg',
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{img:'http://47.94.156.156/home/kenite.jpg',
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
          ],



          phoneDataImg:[
            {
              img: require('@/assets/home/phone/sino.jpg'),
//                img:require('@/assets/home/赛诺.jpg'),
              text1:'赛诺医疗',
              text2:'（688108.SH）',
              text3:'中国心脏支架行业第一阵营企业'
            },
            {
              img: require('@/assets/home/phone/viva.jpg'),
              text1:'维亚生物',
              text2:'（01873.HK）',
              text3:'专注于创新药早期研发服务和投资的生物技术公司'
            },
            {
              img: require('@/assets/home/phone/jingxin.jpg'),
              text1:'锦欣生殖',
              text2:'（01951.HK）',
              text3:'中国领先的人类辅助生殖医疗机构'
            },
            {
              img: require('@/assets/home/phone/purui.jpg'),
              text1:'普瑞眼科',
              text2:'',
              text3:'中国领先的眼科专科连锁医院集团'
            },{
              img: require('@/assets/home/phone/anjiesi.jpg'),
              text1:'安杰思医学科技',
              text2:'',
              text3:'消化道微创介入诊疗器械和设备的国际领先企业'
            },
            {
              img: require('@/assets/home/phone/huaketai.jpg'),
              text1:'华科泰',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            },
            {
              img: require('@/assets/home/phone/innuote.jpg'),
              text1:'英诺特',
              text2:'',
              text3:'中国心脏支架行业第一阵营企业'
            }
            ,{
              img: require('@/assets/home/phone/beite.jpg'),
              text1:'三叶草生物制药',
              text2:'',
              text3:'呼吸道病毒快速诊断领先企业'

            }
            ,{
              img: require('@/assets/home/phone/sanyecao.jpg'),
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{
              img: require('@/assets/home/phone/beikang.jpg'),
              //img:'http://47.94.156.156/home/beikang.jpg',
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{
              img: require('@/assets/home/phone/weimou.jpg'),
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
            ,{
              img: require('@/assets/home/phone/kenite.jpg'),
              text1:'成都倍特药业集团',
              text2:'',
              text3:'综合性制药企业，中国医疗工业百强'
            }
          ],



            bg2:require('@/assets/3.jpg'),
            yg:require('@/assets/home/12.png'),
              activities: [{
              id:'1',
              content: '道远资本观察丨新冠病毒确诊的主要检测方法',
              timestamp: '2020年3月21日',
                color:'#e4e7ed'
            }, {
                id:'2',
              content: ' Multitude Therapeutics | rising star for anti-cancer therapy',
              timestamp: '2020年3月20日',
                color:'#e4e7ed'
            }, {
                id:'4',
                content: '道远资本快讯丨华科泰新冠病毒检测试剂盒获欧盟CE认证和ISO 13485认证并开始出口海外',
                timestamp: '2020年3月17日',
                color:'#e4e7ed'
              }, {
                id:'3',
              content: ' 道远资本观察丨创业投资基金减持新规助力生物医药产业投资进入融与退的良性循环',
              timestamp: '2020年3月15日',
                color:'#e4e7ed'
            },{
                id:'5',
              content: 'IVD企业“硬核”仪器为一线保驾护航',
              timestamp: '2020年3月4日',
                color:'#e4e7ed'
            },{
                id:'6',
              content: '道远资本快讯|葛兰素史克与三叶草生物达成新冠病毒疫苗合作',
              timestamp: '2020年2月25日',
                color:'#e4e7ed'
            }]
         }
    },
  mounted() {
    if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
    // if (this._isMobile()) {
    //   console.log("手机端");
    //   this.$router.push('/');
    // } else {
    //   console.log("pc端");
    //   this.$router.push('/');
    // };
    window.onresize = () => {
        return (() => {
          this.width2=document.body.clientWidth;
          if( this.width2>750){
            if(this.widthType=="0"){
              //替换数据
              console.log("切换pc")
              this.bg=require('@/assets/home/banner1.jpg'),
              this.dataImg=this.pcdataImg
              this.widthType="1";

            }
          }else{
            if( this.width2<=750){
              if(this.widthType=="1"){
                //替换数据
                console.log("切换手机")
                this.bg=require('@/assets/home/phonebanner.jpg'),
                this.dataImg=this.phoneDataImg
                this.widthType="0";
              }
            }
          }

        })();
    };
  },
  created() {
    this.getlist()
      console.log("初始化");
      console.log(document.documentElement.clientWidth)
    this.width2=document.documentElement.clientWidth
    if(document.documentElement.clientWidth>750){
      console.log("切换pc")
        //替换数据
        console.log("切换pc")
        this.bg=require('@/assets/home/banner1.jpg'),
          this.dataImg=this.pcdataImg
        this.widthType="1";


    }else{
      if(document.documentElement.clientWidth<=750){
        console.log("切换pc")
          //替换数据
          console.log("切换手机")
          this.bg=require('@/assets/home/phonebanner.jpg'),
            this.dataImg=this.phoneDataImg
          this.widthType="0";
      }
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
      linkRouter(){
        this.$router.push({path:'/yitou/yiyaoxiangmu'})
      },
      timeLineClick(data){
        var varx=data.id;
        this.$router.push({path:'/NewInfo/'+varx})
        // if(varx==1){
        //   this.$router.push({path:'/bingdujiance'})
        // }else if(varx==2)
        // {
        //   this.$router.push({path:'/arnticancertherapy'})
        // }else if(varx==3)
        // {
        //   this.$router.push({path:'/chuangyetouzi'})
        // }else if(varx==4)
        // {
        //   this.$router.push({path:'/huaketaijianceji'})
        // }else if(varx==5)
        // {
        //   this.$router.push({path:'/idvqiye'})
        // }else if(varx==6)
        // {
        //   this.$router.push({path:'/sanyecaohezuo'})
        // }

      },jr(index){
        for(let i=0;i<this.activities.length;i++){
          console.log(index)
          if(i===index){
            this.activities[i].color="rgb(9, 69, 126)"
          }
        }
      },lk(index){
        for(let i=0;i<this.activities.length;i++){
          if(i===index){
            this.activities[i].color="#e4e7ed"
          }
        }
      },yqrth(varx){
        if(varx===1){
          this.yqr=require('@/assets/home/2.jpg')
        }else{
          this.yqr=require('@/assets/home/1.jpg')
        }

      },getlist(){
        this.$axios.post('/newsCenter/getFiveThNews',{}).then(res=>{
          this.activities=res.data.entity
        })
      }
    }
}
</script>
<style scoped>

  .test :hover{
    background: #083A6F;
    z-index: 5;
  }

  .test :hover div{
    color:white !important;
  }
  .imgDiv .tile1{
    font-size:18px;
    font-family:Microsoft YaHei;
    color:rgba(102,100,100,1);
    font-weight:bold;
  }
  @media screen and (max-width: 1210px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
    .is-show-time {
      display: none;
    }
    .show-home-head-tlie2{
      display: none;
    }
    .home-banner{
      background-image: none !important;
    }
  }
 @media screen and (min-width: 750px ) {
   .portfolio-font-EN-size{
     font-size: 2em;
   }
   .portfolio-font-CN-size{
     font-size: 22px;
   }
   .about-font-EN-top{
     margin-top: 50px;
   }
   .text-top{
     margin-top: 70px !important;
   }
   .newBodTop{
     top: 124px;
   }
   .time-line-paddind{
     width: 100%;
     padding-left: 0px;
   }
 }


  @media screen and (max-width: 750px ) {
    .time-line-paddind{
    padding-left: 14px !important;
    }
    .home-news{
      padding: 0px;
      max-width: 750px
    }
    .portfolio-top{
      margin-top: 50px;
    }
    .portfolio-font-EN-size{
      font-size: 2em;
    }

    .portfolio-font-CN-size{
      font-size: 22px;
    }
    .about-font-EN-top{
      margin-top: 14px;
    }
    .text-top{
      margin-top: 14px;
    }
    .newBodTop{
      top: 0px;
    }
  }


  @media screen and (min-width: 1210px){
    .home-banner{
      height: 400px;
    }
    .home-banner-img{
      display: none !important;
    }
    .home-news{
      margin-left: -20px;
      padding: 20px;
    }
    .show-home-head-tlie{
      display: none;
    }
    .portfolio-font-EN-size{
      font-size: 2em;
    }
  }
  .imgDiv .tile2{
    font-size:12px;
    color:rgba(102,100,100,1);
    font-family:Microsoft YaHei;
    font-weight:400;
  }
  /*.imgDiv :hover{*/

    /*color:white;*/
    /*background: #083A6F;*/
  /*}*/
  .imgDiv{
    margin: 0 auto;
    width: 100%;
    display: inline-block;
    margin-top: 34px;
    border-bottom: 1px;
    background-color: #fff;
    box-shadow:0px 0px 13px 0px rgba(127,127,127,0.14);
    position: relative;
    z-index: 5;
  }

  .imgDiv .imgBody{

  }

  .imgDiv .textBody{
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
  }
  .imgDiv .imgBody{
    backgroundSize: cover;
    width: 100%;
    display: inline-block;
    border: 2px;
  }
  @media screen and (max-width:1100px){
    .home-head-txt{
      font-size: 0.9em !important;
    }
    .portfolio-top{
      margin-top: 150px;
    }

  }
  @media screen and (max-width:992px){
    .home-head-txt{
      font-size: 1em !important;
    }
    .portfolio-top{
      margin-top: 150px;
    }


  }
  @media screen and (max-width:800px){
    .home-head-txt{
      font-size: 1em !important;
    }
    .portfolio-top{
      margin-top: 50px;
    }

  }
#introduce .textCol{
    min-width: 400px;
}
  .el-link.is-underline:hover:after{
    border: 0 !important;
  }
.aboutOurDiv{
    margin-top: 42px;
    background: #083A6F;
    width:130px;
height:42px;
font-size:14px;
text-align: center;
line-height: 40px;
font-family:Adobe Heiti Std;
font-weight:normal;
color:rgba(255,255,255,1);
margin-left:47%;
margin-right:auto;
display: inline-block;
}
#introduce .photoCol{
    min-width: 400px;
}

#introduce .text{
    max-width: 520px;
    min-width: 400px;
    position: fixed;
    display: inline-block;
    height: 301px;
    width: 27%;
    background: red;
}

#introduce .photo{
    display: inline-block;
    height: 414px;
    width: 348px;
    background: blue;
}#banner{
   max-height: 400px;
   width: 100%;
   margin: 0 auto;
   background: green;
 }
#mean{

  width: 900px;
  height: 54px;
  margin: 0 auto;
  margin-top: 0px;
  background: red;
}
.csgo{
  margin-left: 130px;
}

  /deep/ .el-menu-item{
    padding: 0px;
  }
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight:bold;
  color:rgba(8,58,111,1);
  border-bottom: 0px;
}

  .block{
    box-shadow:0px 0px 13px 0px rgba(127,127,127,0.14);
  }
  .home-text{
    cursor: pointer;
  }
  .home-text:hover{
    color: #083A6F;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue